import {
  Button,
  InputLabel,
  Stack,
  Typography,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Alert,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useRef, useState } from "react";
import { APP_LOGO } from "../../assets";
import AuthContainer from "../../components/containers/AuthContainer";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import AppLoader from "../../components/loader/loader";
import TextInput from "../../components/textInput";

const AccountDeletion = () => {
  const constants = useRef(null);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [reason, setReason] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [confirmDeletion, setConfirmDeletion] = useState(false);
  const [confirmDataLoss, setConfirmDataLoss] = useState(false);

  const deletionReasons = [
    "No longer need the service",
    "Privacy concerns",
    "Unsatisfied with the service",
    "Created a new account",
    "Too many notifications",
    "Security concerns",
    "Other",
  ];

  const handleOpenSnackBar = (type, message) => {
    if (constants.current) {
      constants.current.isOpenSnack({
        snackType: type,
        snackMessage: message,
      });
    }
  };

  const handleSubmit = () => {
    if (!name.trim()) {
      handleOpenSnackBar("error", "Name is required");
      return;
    }
    if (!email.trim()) {
      handleOpenSnackBar("error", "Email is required");
      return;
    }
    if (!phone.trim()) {
      handleOpenSnackBar("error", "Phone number is required");
      return;
    }
    if (!reason.trim()) {
      handleOpenSnackBar("error", "Please select a reason for deletion");
      return;
    }
    if (!confirmDeletion) {
      handleOpenSnackBar(
        "error",
        "Please confirm that you want to delete your account"
      );
      return;
    }
    if (!confirmDataLoss) {
      handleOpenSnackBar(
        "error",
        "Please confirm that you understand data will be permanently lost"
      );
      return;
    }

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      handleOpenSnackBar(
        "success",
        "Your account deletion request has been submitted. Our team will process it within 30 days."
      );
      setName("");
      setEmail("");
      setPhone("");
      setReason("");
      setAdditionalInfo("");
      setConfirmDeletion(false);
      setConfirmDataLoss(false);
    }, 2000);
  };

  return (
    <AuthContainer>
      <Stack alignItems="center">
        <img src={APP_LOGO.appLogo} width={177} alt="App Logo" />
      </Stack>

      <Typography my={2} fontSize="1.5rem" fontWeight={600} textAlign="center">
        Account Deletion Request
      </Typography>
      <Typography textAlign="center" color="text.secondary" mb={2}>
        We're sorry to see you go. Please fill out this form to request account
        deletion. Your request will be processed within 30 days.
      </Typography>

      <Alert severity="warning" sx={{ mb: 2 }}>
        <Typography variant="body2" fontWeight={500}>
          Important: Account deletion is permanent and cannot be undone. All
          your data, including job history, messages, and account information
          will be permanently deleted.
        </Typography>
      </Alert>

      <Grid container mt={2}>
        <Grid item xs={12} md={12} width={"100%"}>
          <InputLabel className="input-label">Full Name</InputLabel>
          <TextInput
            placeholder="Enter your full name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={12} width={"100%"}>
          <InputLabel className="input-label">Email Address</InputLabel>
          <TextInput
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={12} width={"100%"}>
          <InputLabel className="input-label">Phone Number</InputLabel>
          <TextInput
            placeholder="Enter your phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={12} width={"100%"}>
          <InputLabel className="input-label">Reason for Deletion</InputLabel>
          <TextInput
            select
            placeholder="Select reason for deletion"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          >
            {deletionReasons.map((reason) => (
              <MenuItem key={reason} value={reason}>
                {reason}
              </MenuItem>
            ))}
          </TextInput>
        </Grid>
        <Grid item xs={12} md={12} width={"100%"}>
          <InputLabel className="input-label">
            Additional Information (Optional)
          </InputLabel>
          <TextInput
            placeholder="Please provide any additional details about your reason for deletion..."
            multiline
            rows={3}
            value={additionalInfo}
            onChange={(e) => setAdditionalInfo(e.target.value)}
          />
        </Grid>
      </Grid>

      <Stack spacing={2} mt={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={confirmDeletion}
              onChange={(e) => setConfirmDeletion(e.target.checked)}
              color="primary"
            />
          }
          label="I confirm that I want to delete my account permanently"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={confirmDataLoss}
              onChange={(e) => setConfirmDataLoss(e.target.checked)}
              color="primary"
            />
          }
          label="I understand that all my data will be permanently deleted and cannot be recovered"
        />
      </Stack>

      <Button
        variant="contained"
        onClick={handleSubmit}
        disabled={loading}
        sx={{ mt: 3, height: 45 }}
        fullWidth
        color="error"
      >
        {loading ? "Submitting Request..." : "Submit Deletion Request"}
      </Button>

      <AppLoader isVisible={loading} />
      <CustomSnackbar ref={constants} />
    </AuthContainer>
  );
};

export default AccountDeletion;
